<template>
  <div class="home">
    <div class="searchBox">
      <div class="title">畅游山水</div>
      <div class="sub_title">感受大自然的魅力</div>
      <div class="name">一站式智慧旅游平台</div>

    </div>
    <div class="contentBox" :style="{backgroundImage: 'url(/beijingtu/pc.jpg)'}">
      <!-- 数据统计 -->


      <!-- 热门攻略 -->
      <div class="article data_item">
        <div class="topTitle">热门攻略</div>
        <div class="articleBox">
          <div class="left" @click="$toArtetails(selectLeft.id)">
            <el-image v-if="selectLeft.image_input" :src="selectLeft.image_input" class="img"></el-image>
            <div class="title">{{ selectLeft.title }}</div>
          </div>
          <div class="right">
            <div class="item" v-for="(item, index) in selectData" :key="index" @click="$toArtetails(item.id)">
              <el-image v-if="item.image_input" :src="item.image_input" class="image"></el-image>
              <div>
                <div class="titleBox">
                  <!-- <div class="tag">基础知识</div> -->
                  <div class="title">{{ item.title }}</div>
                </div>
                <div class="infoBox">
                  <div class="date">
                    <svg t="1734157326409" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="4338" width="14" height="14">
                      <path
                        d="M511.968002 60.371283c249.052543 0 451.644715 202.62417 451.644716 451.660715 0 249.076541-202.592172 451.676713-451.644716 451.676712-249.044543 0-451.660714-202.600172-451.660714-451.676712 0-249.036544 202.616171-451.660714 451.660714-451.660715m0-60.307288C229.190095 0.063995 0 229.24609 0 512.031998c0 282.769909 229.190095 511.984001 511.968002 511.984001 282.737911 0 511.952004-229.214093 511.952004-511.984001C1023.920006 229.24609 794.705914 0.063995 511.968002 0.063995z"
                        fill="#666666" p-id="4339"></path>
                      <path
                        d="M643.813702 674.419311a29.997656 29.997656 0 0 1-21.318334-8.775314L490.649668 534.262261a30.133646 30.133646 0 0 1-8.863308-21.350332V230.222014c0-16.662698 13.486946-30.157644 30.157644-30.157644s30.149645 13.486946 30.149645 30.157644v270.178892l122.990391 122.542427a30.141645 30.141645 0 0 1-21.270338 51.475978z"
                        fill="#666666" p-id="4340"></path>
                    </svg>
                    {{ $dateFormat(item.createtime) }}
                  </div>
                  <div class="number">
                    <svg t="1734157396802" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="5555" width="14" height="14">
                      <path
                        d="M928.842245 512.091074c0-5.006014-0.846274-9.193383-1.086751-9.691733-0.182149-2.480494-1.028423-7.001461-1.815345-9.374508-0.210801-0.590448-0.484024-1.209548-0.724501-1.799996-0.424672-1.360997-0.876973-2.691295-1.390673-3.749394-76.871785-168.137395-242.376213-281.144168-411.782507-281.144168-169.375595 0-334.865697 112.902396-411.388535 280.130072-0.921999 1.815345-1.572822 3.553942-1.981121 5.066389-0.181125 0.49835-0.39295 0.967024-0.558725 1.406023-1.512447 4.430916-1.542122 7.514137-1.421372 6.712889-0.710175 3.251044-1.360997 9.722432-1.360997 9.722432-0.181125 1.949398-0.181125 3.50687 0.030699 5.442966 0 0 0.649799 5.65479 0.968048 6.80294 0.090051 1.602498 0.483001 3.931542 0.951675 6.048763l-0.030699 0c0.408299 1.814322 0.968048 3.568269 1.738597 5.291516 0.393973 1.330298 0.862647 2.570545 1.270946 3.507894 76.976162 168.166047 242.436588 281.20352 411.781484 281.20352 169.436994 0 334.941422-112.945375 410.936233-279.328823 1.177825-2.177596 1.935072-4.233418 2.448772-6.018064 0.2415-0.543376 0.454348-1.027399 0.604774-1.511423 1.331321-3.872191 1.602498-7.227612 1.481747-7.227612l-0.028653 0.029676C928.027693 520.921183 928.842245 516.89959 928.842245 512.091074zM872.717993 514.146896c-0.029676 0.121773-0.091074 0.272199-0.151449 0.393973-0.090051 0.36225-0.240477 0.785899-0.332575 1.209548-68.403926 147.420561-212.830293 246.337431-360.191502 246.337431-146.997935 0-291.168476-98.642624-360.252901-246.578931-0.166799-0.5137-0.287549-0.998747-0.468674-1.481747-0.030699-0.484024-0.12075-0.876973-0.150426-1.150196-0.060375-0.300852-0.12075-0.724501-0.166799-1.088798l0-0.3776c0.166799-0.620124 0.286526-1.239224 0.347924-1.919722 0.12075-0.36225 0.211824-0.710175 0.347924-1.103124C220.132094 360.89042 364.680235 261.928524 512.041444 261.928524c147.420561 0 291.940049 99.051947 360.161826 246.322082 0.060375 0.287549 0.121773 0.530073 0.212848 0.726547 0.060375 0.2415 0.119727 0.484024 0.240477 0.740874 0.151449 1.104147 0.272199 2.192945 0.423649 2.736321C872.899118 513.028423 872.809067 513.572822 872.717993 514.146896z"
                        fill="#666666" p-id="5556"></path>
                      <path
                        d="M512.041444 373.060601c-76.598562 0-138.954749 62.325487-138.954749 138.939399 0 76.598562 62.356187 138.954749 138.954749 138.954749 76.598562 0 138.954749-62.356187 138.954749-138.954749C650.996193 435.386088 588.640006 373.060601 512.041444 373.060601zM512.041444 595.372849c-45.935192 0-83.371826-37.406958-83.371826-83.371826 0-45.950542 37.436634-83.356476 83.371826-83.356476 45.964868 0 83.373873 37.406958 83.373873 83.356476C595.414293 557.965891 558.006312 595.372849 512.041444 595.372849z"
                        fill="#666666" p-id="5557"></path>
                    </svg>
                    {{ item.visit }}
                  </div>
                </div>
                <div class="content">
                  {{ item.synopsis }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 必游景点 -->
      <div class="resourceBox data_item">
        <div class="topTitle">必游景点</div>
        <el-row class="resourceContent" :gutter="20">
          <el-col :span="12" v-for="(item, index) in resouseList" :key="index" @click="$toArtetails(item.id)">
            <div class="item">
              <div class="image" v-if="item.image_input">
                <el-image :src="item.image_input" class="banner"></el-image>
              </div>
              <div class="content">
                <div class="title">{{ item.title }}</div>
                <div class="number">浏览量 <span>{{ item.visit }}</span> </div>
                <div class="date">{{ $dateFormat(item.createtime) }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 精彩瞬间 -->
      <div class="practiceBox data_item">
        <div class="topTitle">精彩瞬间</div>
        <el-row class="practiceContent" :gutter="20">
          <el-col :span="8" v-for="(item, index) in caseList" :key="index" @click="$toArtetails(item.id)">
            <div class="item">
                <el-image v-if="item.image_input" :src="item.image_input" class="image"></el-image>
              <div class="content">
                <div class="title">{{ item.title }}</div>
                <div class="date">{{ $dateFormat(item.createtime) }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      resouseList: [],
      caseList: [],
      selectLeft: {},
      selectData: []
    }
  },
  mounted() {
    this.getResouseListData()
    this.getCaseList()
    this.getSelected()
  },
  methods: {
    async getResouseListData() {
      // 资源推荐
      const data = await this.$getList(19);
      this.resouseList = data.splice(0, 4)
    },
    // 案例
    async getCaseList() {
      const data = await this.$getCateList(8);
      const list = await this.$getList(data[0] && data[0].id);
      this.caseList = list.splice(0, 6)
    },
    // 精选文章
    async getSelected() {
      const data = await this.$getList();
      this.selectLeft = data[0]
      this.selectData = data.splice(1, 3)
    }
  },
}
</script>
<style scoped lang="scss">
// Premium font stack
.home {
  width: 100%;
  min-height: 100vh;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  background-color: #f7f9fc; // Premium light gray background for the whole page

  .searchBox {
    width: 100%;
    height: 750px; 
    // background: url("../assets/banner.png") no-repeat center center;
    // background-size: cover;
    //红色渐变背景 
    background: linear-gradient( #8d1e23 0%, #FFF 100%);
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    overflow: hidden;

    // Gradient Overlay for better text readability
    // &::before {
    //   content: '';
    //   position: absolute;
    //   inset: 0;
    //   background: linear-gradient(135deg, rgba(30, 148, 147, 0.6) 0%, rgba(66, 185, 131, 0.4) 100%);
    //   backdrop-filter: blur(2px);
    // }

    // Ensure content sits above overlay
    > * {
      position: relative;
      z-index: 2;
    }

    .title {
      font-size: 72px;
      font-weight: 800;
      color: #FFFFFF;
      letter-spacing: 4px;
      margin-bottom: 20px;
      margin-top: 0;
      text-shadow: 0 10px 20px rgba(0,0,0,0.2);
      animation: fadeInDown 1s ease-out;
    }

    .sub_title {
      font-size: 32px;
      font-weight: 300;
      color: #FFFFFF;
      letter-spacing: 2px;
      margin-bottom: 30px;
      text-shadow: 0 5px 15px rgba(0,0,0,0.2);
      animation: fadeInUp 1s ease-out 0.2s backwards;
    }

    .name {
      background: rgba(255, 255, 255, 0.2);
      border: 1px solid rgba(255, 255, 255, 0.3);
      backdrop-filter: blur(10px);
      border-radius: 50px;
      padding: 10px 40px;
      font-size: 20px;
      color: #FFFFFF;
      margin: 0 auto 60px;
      width: fit-content;
      animation: fadeInUp 1s ease-out 0.4s backwards;
      cursor: default;
    }

    .searchInput {
      width: 100%;
      max-width: 900px;
      margin: 0 auto;
      animation: fadeInUp 1s ease-out 0.6s backwards;

      ::v-deep .el-input-group {
         border: none;
         background: rgba(255,255,255,0.95);
         border-radius: 60px;
         padding: 6px;
         box-shadow: 0 15px 35px rgba(0,0,0,0.2);
         height: auto; // Let padding define height
      }
      
      ::v-deep .el-input__wrapper {
         box-shadow: none !important;
         background: transparent;
      }

      ::v-deep .el-input__inner {
         height: 50px;
         font-size: 18px;
         color: #333;
         padding-left: 20px;
      }

      ::v-deep .el-input-group__append {
         background-color: #851C20;
         border-radius: 50px;
         color: #fff;
         border: none;
         margin: 0;
         padding: 0 40px;
         height: 50px;
         display: flex;
         align-items: center;
         justify-content: center;
         cursor: pointer;
         transition: all 0.3s;
         box-shadow: 0 4px 15px rgba(133, 28, 32, 0.4);

         &:hover {
           background-color: #A6252C;
           transform: scale(1.02);
         }
         
         .el-button {
           background: transparent;
           border: none;
           color: #fff;
           font-size: 18px;
           padding: 0;
           display: flex;
           align-items: center;
           margin: 0;
           height: auto;
           
           span {
             display: flex;
             align-items: center;
           }
         }
      }
    }

    .searchTagBox {
      display: flex;
      justify-content: center;
      margin-top: 30px;
      flex-wrap: wrap;
      animation: fadeInUp 1s ease-out 0.8s backwards;

      .item {
        padding: 8px 20px;
        background: rgba(0,0,0,0.3);
        border: 1px solid rgba(255,255,255,0.2);
        border-radius: 30px;
        font-size: 14px;
        color: #fff;
        margin: 0 10px 10px 0;
        cursor: pointer;
        transition: all 0.3s;
        
        &:hover {
          background: #A6252C;
          border-color: #A6252C;
          transform: translateY(-2px);
        }
      }
    }
  }

  .contentBox {
    padding: 80px 0;
    // Force override background to ensure consistency
    background-color: #f7f9fc !important; 
    background-image: none !important; 

    .topTitle {
      font-size: 40px;
      font-weight: 700;
      color: #333;
      text-align: center;
      margin-bottom: 60px;
      position: relative;
      
      &::after {
        content: '';
        display: block;
        width: 80px;
        height: 6px;
        background: linear-gradient(90deg, #851C20, #A6252C);
        margin: 20px auto 0;
        border-radius: 4px;
      }
    }

    .data_item {
      max-width: 1280px; // Wider container
      margin: 0 auto 100px;
      padding: 0 20px;
    }

    // Data Static
    .dataStatic {
       background: #fff;
       border-radius: 20px;
       padding: 40px;
       box-shadow: 0 10px 40px rgba(0,0,0,0.06);

       p {
         color: #555;
         line-height: 1.8;
         font-size: 16px;
       }
       
       .echartsBox {
         margin-top: 40px;
       }
    }

    // Article Box
    .articleBox {
      display: flex;
      gap: 40px;
      
      .left {
        width: 600px;
        flex-shrink: 0;
        border-radius: 16px;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        box-shadow: 0 15px 35px rgba(0,0,0,0.1);

        .img {
           width: 100%;
           height: 100%;
           object-fit: cover;
           min-height: 400px;
           transition: transform 0.6s;
        }

        .title {
           position: absolute;
           bottom: 0;
           left: 0;
           width: 100%;
           padding: 30px;
           background: linear-gradient(to top, rgba(0,0,0,0.85), transparent);
           color: #fff;
           font-size: 22px;
           font-weight: 600;
           box-sizing: border-box;
           line-height: 1.4;
        }

        &:hover .img {
           transform: scale(1.05);
        }
      }

      .right {
        flex: 1;
        display: flex;
        flex-direction: column;

        .item {
           display: flex;
           align-items: center;
           padding: 20px;
           background: #fff;
           border-radius: 16px;
           box-shadow: 0 5px 15px rgba(0,0,0,0.03);
           cursor: pointer;
           transition: all 0.3s;
           border: 1px solid #f0f0f0;
           margin-bottom: 20px;
           height: 100%;

           &:last-child {
             margin-bottom: 0;
           }

           &:hover {
             transform: translateY(-5px);
             box-shadow: 0 15px 30px rgba(0,0,0,0.08);
             border-color: rgba(133, 28, 32, 0.2);
           }

           .image {
             width: 150px;
             border-radius: 10px;
             object-fit: cover;
             margin-right: 25px;
             flex-shrink: 0;
           }

           > div {
             flex: 1;
             overflow: hidden;
           }

           .title {
             font-size: 18px;
             font-weight: 600;
             color: #333;
             margin-bottom: 15px;
             white-space: nowrap;
             overflow: hidden;
             text-overflow: ellipsis;
           }
           
           .titleBox {
             display: flex;
             align-items: center;
             margin-bottom: 10px;
             
             .tag {
               background: #A6252C;
               color: #fff;
               padding: 2px 8px;
               font-size: 12px;
               border-radius: 4px;
               margin-right: 10px;
             }
           }

           .infoBox {
             display: flex;
             align-items: center;
             color: #999;
             font-size: 13px;
             
             .date, .number {
               display: flex;
               align-items: center;
               margin-right: 20px;
               
               .icon {
                  margin-right: 6px;
               }
             }
           }
           
           .content {
              display: none; 
           }
        }
      }
    }

    // Resource Grid
    .resourceContent {
       margin: 0;
       
       .el-col {
          margin-bottom: 30px;
       }

       .item {
          background: #fff;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 20px rgba(0,0,0,0.05);
          transition: all 0.4s ease;
          display: flex;
          height: 180px;
          cursor: pointer;
          border: 1px solid #f0f0f0;

          &:hover {
             transform: translateY(-5px);
             box-shadow: 0 20px 40px rgba(0,0,0,0.1);
             border-color: #A6252C;
          }

          .image {
             width: 300px;
             height: 100%;
             flex-shrink: 0;
             overflow: hidden;
             
             .banner {
               width: 100%;
               height: 100%;
               object-fit: cover;
               transition: transform 0.6s;
             }
          }
          
          &:hover .image .banner {
             transform: scale(1.1);
          }

          .content {
             flex: 1;
             padding: 25px;
             display: flex;
             flex-direction: column;
             justify-content: space-between;

             .title {
                font-size: 20px;
                font-weight: 600;
                color: #333;
                line-height: 1.4;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
             }

             .number {
                font-size: 14px;
                color: #666;
                margin-top: auto;
                
                span {
                   color: #C7181D;
                   font-weight: 700;
                   font-size: 16px;
                   margin-left: 5px;
                }
             }

             .date {
                font-size: 13px;
                color: #999;
                margin-top: 5px;
             }
          }
       }
    }

    // Practice Grid
    .practiceContent {
       .el-col {
         margin-bottom: 30px;
       }

       .item {
         background: #fff;
         border-radius: 16px;
         overflow: hidden;
         box-shadow: 0 10px 30px rgba(0,0,0,0.05);
         transition: all 0.4s;
         cursor: pointer;
         height: 100%;
         display: flex;
         flex-direction: column;
         border: 1px solid #f0f0f0;

         &:hover {
           transform: translateY(-8px);
           box-shadow: 0 25px 50px rgba(0,0,0,0.12);

           .image {
             transform: scale(1.05);
           }
         }

         .image {
            width: 100%;
            height: 240px;
            object-fit: cover;
            transition: transform 0.6s;
            display: block;
         }

         .content {
            padding: 25px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .title {
               font-size: 18px;
               font-weight: 600;
               color: #333;
               line-height: 1.5;
               margin-bottom: 15px;
               display: -webkit-box;
               -webkit-line-clamp: 2;
               line-clamp: 2;
               -webkit-box-orient: vertical;
               overflow: hidden;
            }

            .date {
               font-size: 14px;
               color: #999;
            }
         }
       }
    }
  }

  // Animation Keyframes
  @keyframes fadeInDown {
    from { opacity: 0; transform: translateY(-30px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(30px); }
    to { opacity: 1; transform: translateY(0); }
  }
}
</style>
